import { get } from '@/utils/Api'
import UrlStore from '@/utils/UrlStore'

/**
 * The /home screen's own endpoints.
 *
 * No state: the onboarding answer is read when the screen opens and is stale the moment the
 * administrator acts on it, so there is nothing here worth keeping between visits. The
 * module exists so the screen asks the store rather than axios, the way every other screen
 * does - and so the summary endpoint has somewhere to land.
 */
export default {
  namespaced: true,
  actions: {
    onboardingLoad() {
      return get(`/${UrlStore.HOME_ONBOARDING}`)
    },
    summaryLoad(context, config = {}) {
      return get(`/${UrlStore.HOME_SUMMARY}`, config)
    }
  }
}
